module.exports = __webpack_public_path__ + "img/tab_analytics.87ad5c49.svg";